const getNotices = (store => (store.notices && store.notices.results) || []);

export default getNotices;
